import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { finalize, Subscription } from 'rxjs';

import { ChangeManagerService } from '../../../change-manager.service';

@Component({
  host: {
    'test-id': 'fw-save-bar',
    '[class.activated]': 'activated',
  },
  selector: 'fw-save-bar',
  styleUrls: ['./fw-save-bar.component.scss'],
  templateUrl: './fw-save-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FwSaveBarComponent implements OnDestroy {
  activated = false
  saving = false
  valid = false

  private subscription = Subscription.EMPTY

  constructor(
    private cdr: ChangeDetectorRef,
    private changeManager: ChangeManagerService,
  ) {
    this.subscription = this.changeManager.status$.subscribe(status => {
      this.activated = status.dirty;
      this.valid = status.valid;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get saveEnabled(): boolean {
    return this.valid && !this.saving;
  }

  save(): void {
    this.saving = true;
    this.cdr.markForCheck();
    this.changeManager.save().pipe(
      finalize(() => {
        this.saving = false;
        this.cdr.markForCheck();
      }),
    ).subscribe();
  }

  reset(): void {
    this.changeManager.reset();
  }
}
